import React, { useState, useRef, useEffect } from "react";
import { BrowserRouter, Switch, Route, Link, Redirect, useHistory } from "react-router-dom";
import { scroller } from "react-scroll";
import axios from "axios";
import "./Sass/style.scss";
import Privacy from './privacy';

function Home() {
  const [checkout, setCheckout] = useState(false);
  const [price, setPrice] = useState("0.00");
  const [option, setOption] = useState("");
  const [email, setEmail] = useState("");
  const [brand, setBrand] = useState("");
  const [showSuccess, setShowsuccess] = useState(false);
  const [success, setSuccess] = useState(false);
  /* show payment error */
  const [error, setError] = useState(null);


  /* CONTACT */
  const [showcontact, setShowcontact] = useState(false);
  const [contactname, setContactname] = useState("");
  const [contactemail, setContactemail] = useState("");
  const [contactmessage, setContactmessage] = useState("");
  const [showmessagesent, setShowmessagesent] = useState(false);
  const [messageError, setMessageError] = useState(false);

  let scrollToSection = () => {
    scroller.scrollTo("errDiv", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  let scrollToPackages = () => {
    scroller.scrollTo("getStarted", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  const closeCheckout = () => {
    setCheckout(false);
  };

  const openCheckout = (data) => {
    setCheckout(true);
    setPrice(data.price);
    setOption(data.package);
  };


  function submitContact() {
    if(contactname.length > 0 && contactemail.length > 0 && contactmessage.length > 0){
      axios
      .post("/api/contact", {
        name: contactname,
        email: contactemail,
        message: contactmessage,
      })
      .then(function (response) {
        console.log(response.data.status);
        if (response.data.status) {
          //success
          //clear form
          setContactname("");
          setContactemail("");
          setContactmessage("");
          setShowcontact(false);
          setShowmessagesent(true);
          setMessageError(false);
        } else {
          //show error
          setMessageError(true);
        }
      })
      .catch(function (error) {
        setMessageError(true);
      });
    } else {
      setMessageError(true);
    }
  }

  function MessageSent() {
    return (
      <div>
        <div className="final-window text-center">
          <div className="col-lg-6 ml-auto mr-auto">
            <img
              src="https://alohe.github.io/emojicloud/svg/Mailbox.svg"
              width="200px"
            />
            <p>Your message has been sent! We will get back to you asap.</p>
            <button
              className="action-btn"
              onClick={() => {
                setShowmessagesent(false);
                setShowcontact(false);
              }}
            >
              Back to home
            </button>
          </div>
        </div>
      </div>
    );
  }

  function Paidfail() {
    return (
      <div>
        <div className="final-window text-center">
          <div className="col-lg-6 ml-auto mr-auto">
            <img
              src="https://alohe.github.io/emojicloud/svg/Grimacing face.svg"
              width="200px"
            />
            <p>
              Ooops! Something went wrong while trying to place your order{" "}
              <br />
              You have not been charged Please Try again
            </p>
            <button
              className="action-btn"
              onClick={() => {
                setCheckout(false);
                setShowsuccess(false);
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  function Success() {
    return (
      <div>
        <div className="final-window text-center">
          <div className="col-lg-6 ml-auto mr-auto">
            <img
              src="https://alohe.github.io/emojicloud/svg/Party popper.svg"
              width="200px"
            />
            <p>
              Your Order has been placed Please check your Email to confirm, and
              we will contact you soon
            </p>
            <button
              className="action-btn"
              onClick={() => {
                setCheckout(false);
                setShowsuccess(false);
              }}
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  
  const paymentApproved = (name, orderID) => {
    axios
      .post("/api/paymentapproved", {
        name: name,
        email: email,
        brand: brand,
        orderID: orderID,
      })
      .then(function (response) {
        console.log(response.data.status);
        if (response.data.status) {
          //success
          //clear form
          setEmail("");
          setBrand("");
          setSuccess(true);
          setShowsuccess(true);
        } else {
          //show error
          setSuccess(false);
          setShowsuccess(true);
        }
      })
      .catch(function (error) {
        //show error
        setSuccess(false);
        setShowsuccess(true);
      });
  };

  function Product({product}){
    const paypalRef = useRef();
    
    useEffect(() => {
      window.paypal.Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  description: product.description,
                  amount: {
                    currency_code: "USD",
                    value: product.price,
                  },
                },
              ],
            });
          },
          onApprove: async (data, actions) => {
            return await actions.order.capture().then(function (details) {
              console.log(details);
              // Show a success message to your buyer
              // OPTIONAL: Call your server to save the transaction
              paymentApproved(
                details.payer.name.given_name,
                data.orderID
              );
              setError(false)
              //show success
            });
          },
          onError: (err) => {
            setError(true);
          },
        })
        .render(paypalRef.current);
    }, [product.description, product.price]);
    return (
      <div ref={paypalRef} />
    );
  }

  const product1 = {
    price: 249,
    name: "3-5 days",
    description: "Get your brand name approved on Amazon within 3-5 days",
  };
  
  const product2 = {
    price: 449,
    name: " 24-48 hours",
    description: "Get your brand name approved on Amazon within 24-48 hours",
  };

  return (
    <div>
      <header className="row m-0 p-4 header">
        <div className="mr-auto">
          <h4 className="logo">Error 5665</h4>
        </div>
        <div className=" row m-0">
          <button className="nav-btn pc" onClick={scrollToSection}>
            The Error
          </button>
          <button className="action-btn get-started" onClick={scrollToPackages}>
            Get Started
          </button>
        </div>
      </header>

      <div className="main">
        <div className="row hero">
          <div className="col-lg-5 ml-auto mr-auto pt-5 mobile">
            {" "}
            <img
              src="/img/17.png"
              draggable="false"
              alt=""
              className="img-fluid floater"
            />
          </div>
          <div className="col-lg-6 inner">
            <h1 className="title">
              We help you create a product without a trademark needed
            </h1>
            <p className="description">
              As per new changes on seller central, Amazon sellers are required
              to get brand name approval to list their first product on Amazon.
              As a newbie or a beginner seller you might not want to register a
              trademark and pay huge fees to lawyers to get a trademark of your
              desired brand name and wait for months for approval.
              <br />
              <small className="font-weight-bold">
                We can register your brand in the matter of days not months!
              </small>
            </p>
            <button
              className="action-btn get-started"
              onClick={scrollToPackages}
            >
              Get Started
            </button>
          </div>
          <div className="col-lg-6 ml-auto mr-auto pl-5 pb-5 pr-5 pt-4 pc">
            {" "}
            <img
              src="/img/17.png"
              draggable="false"
              alt=""
              className="img-fluid floater"
            />
          </div>
        </div>

        <div className="section col-lg-11 ml-auto mr-auto row errDiv">
          <div className="text-center col-lg-6 item-gallery">
            <figure>
              <a href="/img/c700d-amazon-error.png" data-size="2000x1173">
                <img
                  src="/img/c700d-amazon-error.png"
                  className="img-fluid err-image"
                  alt="Amazon Error 5665"
                />
              </a>
            </figure>
          </div>
          <div className="text-left col-lg-6 text-section">
            <h4 className="title">
              {" "}
              Has this frustrating scenario happened to you?
            </h4>
            <p className="description">
              You're trying to create a listing for your Amazon private label
              product, but it does not accept your brand name - instead you're
              stopped in your tracks by this error message
              <br />
              <b>We're here to help!</b>
            </p>
            <button
              className="action-btn get-started"
              onClick={scrollToPackages}
            >
              Get started
            </button>
          </div>
        </div>

        <div className="section col-lg-11 ml-auto mr-auto pl-3 pr-3 getStarted">
          <div className="text-center col-lg-7 ml-auto mr-auto mb-5">
            <h5 className="title">Simple Pricing</h5>
            <p className="t-secondary">
              We will get your brand name registered in Amazon's system in the
              matter of days not months with a fraction of the price!
            </p>
          </div>
          <div className="row m-0 packages">
            {/* checkout option one */}
            <div className="ml-auto package-1">
              <h1 className="price">
                <small>$</small>249
              </h1>
              <p className="feature text-left">
                <i className="fa fa-check"></i> Takes 3-5 days
              </p>
              <p className="feature text-left">
                <i className="fa fa-check"></i> Money Back guarantee
              </p>
              <button onClick={() => openCheckout({ price: 249, package: 1 })}>
                Purchase
              </button>
            </div>
            {/* checkout option 2 */}
            <div className="mr-auto package-2">
              <h1 className="price">
                <small>$</small>449
              </h1>
              <p className="feature text-left">
                <i className="fa fa-check mr-2"></i> 48 hours!
              </p>
              <p className="feature text-left">
                <i className="fa fa-check mr-2"></i> Money Back guarantee
              </p>
              <button onClick={() => openCheckout({ price: 449, package: 2 })}>
                Purchase
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        className="contact-btn pulse"
        onClick={() => {
          setShowcontact(true);
        }}
      >
        <i className="fa fa-comment" />
      </button>

      <footer className="mt-5 mb-5">
        <div className="container top">
          <div className=" text-center">
            <p>
              © 2021 Error5665.com
              <font className="t-secondary">•</font>
              <Link to="/privacypolicy" className="t-blue">
                <a>Privacy Policy</a>
              </Link>
            </p>
          </div>
        </div>
      </footer>

      {checkout ? (
        <div className="popup" id="checkoutModal">
          <div className="background cross" onClick={closeCheckout}></div>
          <div className={["inner active slidein"]} id="checkoutInner">
            <h1 className="t-bold mb-0 title">Checkout</h1>
            <p className="small t-light">Finalize your order</p>
            <button className="close-btn cross" onClick={closeCheckout}>
              <i className="fa fa-times"></i>
            </button>

            <form action="" className="checkout-form">
              <div className="custom-row">
                <div className="input">
                  <input
                    type="email"
                    id="email"
                    className={`is-value ${email.length > 0 ? "active" : ""}`}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    required
                  />
                  <label htmlFor="email">Your Email</label>
                </div>
              </div>
              <p className="notice">
                <font className="font-weight-bold">NOTE:</font> USE EXACT
                SPELLING on how you want the brand to show CAPS included
              </p>
              <div className="input">
                <input
                  type="text"
                  className={`is-value ${brand.length > 0 ? "active" : ""}`}
                  onChange={(e) => {
                    setBrand(e.target.value);
                  }}
                  id="brand"
                  required
                />
                <label htmlFor="brand">
                  Brand name you are trying to post under
                </label>
              </div>
              <hr className="p-0 mt-0 mb-3" />
              <div className="ver pb-0 text-dark">
                <p className="font-weight-bold">Total</p>
                <p className="font-weight-bold">${price}</p>
              </div>
              <hr className="p-0 mt-0 mb-4" />
              {error ? (
                <p className="badge badge-danger small">
                  An Error occurred while trying to complete your payment (you
                  have not been charged) please try again.
                </p>
              ) : (
                ""
              )}
              {option === 1 ? (
                <Product product={product1} />
              ) : (
                <Product product={product2} />
              )}
            </form>
          </div>
        </div>
      ) : (
        ""
      )}
      {/* final window */}
      {showSuccess ? showSuccess && success ? <Success /> : <Paidfail /> : ""}
      {showmessagesent ? <MessageSent /> : ""}
      {showcontact ? (
        <div className="popup">
          <div
            className="background"
            onClick={() => {
              setShowcontact(false);
            }}
          ></div>
          <div className="contact-inner slidein">
            <button
              className="close-btn cross"
              onClick={() => {
                setShowcontact(false);
              }}
            >
              <i className="fa fa-times"></i>
            </button>
            <h4 className="title">Contact Us</h4>
            <p className="mb-0">Have questions about our service? </p>
            {messageError ? (
              <p className="badge badge-danger small">
                An Error occurred while trying to send your message please try
                again.
              </p>
            ) : (
              ""
            )}
            <div className="input">
              <input
                type="text"
                id="contactname"
                className={`is-value ${contactname.length > 0 ? "active" : ""}`}
                onChange={(e) => {
                  setContactname(e.target.value);
                }}
              />
              <label htmlFor="contactname">Name</label>
            </div>
            <div className="input">
              <input
                type="email"
                id="contactemail"
                className={`is-value ${
                  contactemail.length > 0 ? "active" : ""
                }`}
                onChange={(e) => {
                  setContactemail(e.target.value);
                }}
              />
              <label htmlFor="contactemail">Email</label>
            </div>
            <div className="input">
              <textarea
                id="contactmessage"
                className={`is-value ${
                  contactmessage.length > 0 ? "active" : ""
                }`}
                onChange={(e) => {
                  setContactmessage(e.target.value);
                }}
              ></textarea>
              <label htmlFor="contactmessage">Message</label>
            </div>

            <button
              className="action-btn"
              type="button"
              onClick={() => submitContact()}
            >
              <i className="fa fa-paper-plane"></i> Send
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}


function Main() {
  return (
    <div>
      <BrowserRouter>
        <Switch>
          <Route exact path="/privacypolicy" component={Privacy} />
          <Route exact path="/" component={Home} />
        </Switch>
      </BrowserRouter>
    </div>
  );
};


export default Main;



// WEBPACK FOOTER //
// ./src/Home.js